<template>
  <div>
	  Connecting
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import axios from 'axios'
const http = axios.create({
  withCredentials: false,
  crossdomain: true
})
export default {
  name: 'SetupReturn',
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted() {
    var self = this;
    http.post(envConfig.API, JSON.stringify({ a:'SetupOAuthSave', code: self.$route.query.code }), {
      withCredentials: false,
      crossdomain: true,
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(ret => {
      debugger;
      localStorage.setItem('JWT', ret.data.JWT)
      localStorage.setItem('name', ret.data.name)
      self.$router.push('Home') 
    }).catch(function () {
          
        //self.floatmessage = 'Having Trouble Connecting';
      })
  },
  created: function () {
  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>





